import { useState } from "react";

import { Trans } from "react-i18next";

export default function TopUpTypeSelector({ types, value, onChange }) {
  const handleClick = (item) => {
    onChange(item);
  };

  return (
    <div className="top-up-type-wrapper">
      <span><Trans i18nKey="top-up-modal.top-up-type" /></span>

      <div className="top-up-type-content">
        {types.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`top-up-card ${value?.id === item.id ? "active" : ""}`}
            onClick={() => handleClick(item)}
            style={{
              backgroundImage: `url(${item.bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <span>{item.label}</span>

            <span className="fee">+{item.fee * 100}%</span>

            <div
              className={`down ${value?.id === item.id ? "active" : ""}`}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
